import { useState, useEffect } from "react";
//import axios from 'axios';
import { useSelector } from 'react-redux';

const useAPICom = (urltype = "", path = "/", type = "get", headers = { "Content-Type": "application/json" } , data = {}) => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const { MainAPIURL } = useSelector((store) => store.configuration);
    //console.log(process.env.REACT_APP_PYTHON_URL + path);
    var URL = ""
    switch (urltype) {
        case "": URL = MainAPIURL + path; break;
        case "main": URL = MainAPIURL + path; break;
        case "full": URL = path; break;
        default: URL = MainAPIURL + path; break;
    }
    useEffect(() => {
        const fetchData = async (pURL, ptype, pheaders, pdata) => {
            try {
                if (ptype === "get") {
                    const res = await fetch(pURL);
                    const json = await res.json();
                    setResponse(json);
                }
                else if (ptype === "post") {
                    const res = await fetch(pURL, {
                        method: "POST", // *GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: "same-origin", // include, *same-origin, omit
                        headers: pheaders,
                        redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify(pdata), // body data type must match "Content-Type" header
                    });
                    const json = await res.json();
                    setResponse(json);
                }
            } catch (error) {
                setError(error);
            }
        };
        fetchData(URL, type, headers, data);
    }, [path, type, headers, data]);
    return { response, error };
};

export default useAPICom;
